import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Divider, Grid, Typography } from '@mui/material';
import { ViewConneqtPayload } from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { di } from '../../../state/inversify.config';
import { AddNewPlayerModal } from './addNewPlayer.modal';
import { RequestFrom } from './requestFrom.dumb';
import { RequestPlayer } from './requestPlayer.dumb';
import { ResponsePlayer } from './responsePlayer.smart';
import { ConneqtPageQueryService } from '../conneqt.queryParam.service';
import { ReceivedConneqtDomain } from './receivedConneqts.domain';

interface ReceivedRequestsProps {
  pageQueryParam: ConneqtPageQueryService;
}
export function ReceivedRequests({ pageQueryParam }: ReceivedRequestsProps) {
  const { t } = useTranslation();

  const [showAddPlayerModal, setShowAddPlayerModal] = useState(false);

  const { selectedConneqtId } = pageQueryParam.useSelectMergedQuery();

  const receivedConneqtDomain = di.get(ReceivedConneqtDomain);
  const receivedConneqts = receivedConneqtDomain.useReceivedConneqts();

  useEffect(() => {
    if (!selectedConneqtId) return;

    const element = document.getElementById(selectedConneqtId);
    if (!element) return;

    // 👇 Will scroll smoothly to the top of the next section
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [receivedConneqts, selectedConneqtId]);

  return (
    <Grid container spacing={2}>
      {receivedConneqts?.map((conneqt: ViewConneqtPayload) => (
        <Grid item xs={12} sm={12} md={8} lg={4} key={conneqt.id}>
          <Card sx={{ maxWidth: 370 }}>
            <Typography variant="caption" sx={{ p: 2 }}>
              {t('CONNEQTED_FROM')}:
            </Typography>
            <RequestFrom conneqt={conneqt} />
            <Divider />
            <Typography variant="caption" sx={{ p: 2 }}>
              {t('CONNEQT_PLAYER')}:
            </Typography>
            <RequestPlayer conneqt={conneqt} />
            <ResponsePlayer
              conneqt={conneqt}
              setShowAddPlayerModal={setShowAddPlayerModal}
            />
          </Card>
        </Grid>
      ))}

      <AddNewPlayerModal
        showAddPlayerModal={showAddPlayerModal}
        setShowAddPlayerModal={setShowAddPlayerModal}
      />
    </Grid>
  );
}
